const services = [
  {
    title: "Asesoría y atención personalizada.",
    text: "Contamos con atención 24/7 vía correo, chat o sitio web con nuestro equipo de asesores y ajustadores.",
  },
  {
    title: "Notifica siniestros.",
    text: "Envía una notificación al instante con tu ubicación actual y obtén el seguimiento de tu aseguradora.",
  },
  {
    title: "Controla y administra todas tus pólizas.",
    text: "Guarda la información de tus pólizas para poder comparar precios, consultar y gestionar información en cualquier momento.",
  },
  {
    title: "Cotiza y adquiere tu seguro",
    text: "Compara con más de 20 aseguradoras y busca la mejor opción de acuerdo a tus necesidades.",
  },
  {
    title: "Recibe avisos de pago",
    text: "Notificaciones de vencimiento de pago para que siempre estés asegurado y tranquilo.",
  },
];

export default services;
